<template>
  <div class="my-examine">
    <van-sticky :offset-top="0">
      <div class="header">
        <l-header url="/" headerTitle="我的审批"></l-header>
        <div class="query">
          <div class="top">
            <div class="popup-time"
               @click="handleChoice('time')"
            >
              <div class="time">{{ queryDateTitle }}</div>
              <div class="division"></div>
              <span class="top-icon huisuiyunfont">{{'\ue633'}}</span>
            </div>
<!--            <div class="input-search">-->
<!--              123-->
<!--            </div>-->
          </div>
          <div class="bottom">
            <div>
              <l-tab
                :tabList="tabList"
                isBlueLine
                backgroundColor="#fff"
                titleActiveColor="#3378FF"
                titleInactiveColor="#7A8699"
                :handleChange="handleChange"
              ></l-tab>
            </div>
          </div>
        </div>
      </div>
    </van-sticky>
    <div class="main">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          :immediate-check="false"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <van-checkbox-group v-model="selectRows" ref="checkboxGroup">
            <div class="item" v-for="item in tableData" :key="item.id">
              <div class="top">
                <van-checkbox
                  v-if="isToBeOperated"
                  checked-color="#3378ff"
                  icon-size="16px"
                  :name="item"
                  ref="checkboxes"
                />
                <l-card :form-list="cardFormList" :data="item"></l-card>
                <span class="info"
                  @click="$router.push({ path: '/my-examine/page', query: { reimNo: item.reimNo, examineId: item.id } })"
                >
                  详情
                </span>
                <span v-if="!isToBeOperated" class="allIconFont status-icon" :style="{ color: getStatusColor(item.status) }">
                  {{ getStatusIcon(item.status) }}
                </span>
              </div>
              <div class="footer"
                 v-if="isToBeOperated"
              >
                <span @click="handleBtnClick('REJECT', item)">驳回</span>
                <span @click="handleBtnClick('AGREE', item)">通过</span>
              </div>
            </div>
          </van-checkbox-group>
        </van-list>
      </van-pull-refresh>
    </div>
    <footer v-if="isToBeOperated">
      <div class="left">
        <van-checkbox v-model="checkedAll" icon-size="18px" @change="handleCheckAll">全选</van-checkbox>
        <span>共{{ selectRows.length }}条</span>
      </div>
      <div class="right" @click="handleBtnClick('AGREE')">
        批量通过
      </div>
    </footer>
    <Popup ref="popupRef" :current-pop-type="currentPopType" :call-back="popupConfirmCallBack" />
    <l-popup :show.sync="monthPopup" :callBack="handleMonthCallBack"></l-popup>
  </div>
</template>
<script>
import { Sticky, PullRefresh, List, Notify, Empty, Checkbox, CheckboxGroup, Cell, CellGroup } from 'vant'
import Header from '@/components/Header/index.vue'
import Tab from '@/components/Tab/index.vue'
import LPopup from '@/components/NewPopup/index.vue'
import Popup from './popup.vue'
import moment from 'moment'
import { mapState, mapActions } from 'vuex'
import Card from './card.vue'
import { formList, mainResultIconMap } from './config'
export default {
  components: {
    Popup,
    'l-header': Header,
    'l-tab': Tab,
    'l-popup': LPopup,
    'l-card': Card,
    [Sticky.name]: Sticky,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
    [Notify.name]: Notify,
    [Empty.name]: Empty
  },
  data () {
    return {
      operateShow: false,
      monthPopup: {
        flag: false,
        selectTitle: '请选择月份',
        style: { height: '50%' },
        type: 'month'
      },
      currentPopType: '',
      checkedAll: false,
      queryDateTitle: '请选择日期',
      isLoading: false,
      loading: false,
      finished: false,
      selectRows: [],
      selectRow: {},
      query: {
        bizType: 'REIMBURES',
        current: 1,
        size: 25,
        status: 'RUNNING'
      },
      tabList: [
        {
          title: '待审批',
          index: 'RUNNING'
        }, {
          title: '已审批',
          index: 'FINISHED'
        }
      ]
    }
  },
  computed: {
    ...mapState('my-examine', ['tableData', 'total']),
    isToBeOperated () {
      return this.query.status === 'RUNNING'
    },
    cardFormList () {
      return formList
    }
  },
  async mounted () {
    await this.getTableList()
  },
  methods: {
    ...mapActions('my-examine', ['getTableData', 'getTableDataConcat', 'examine']),
    getStatusIcon (status) {
      return mainResultIconMap.get(status).icon
    },
    getStatusColor (status) {
      return mainResultIconMap.get(status).color
    },
    /**
     * @description 点击驳回/通过按钮
     * @param type
     * @param item
     */
    handleBtnClick (type, item) {
      if (!item && !this.selectRows.length) return Notify({ type: 'danger', message: '请先勾选数据' })
      this.selectRow = item
      this.currentPopType = type
      this.$refs.popupRef.show = !this.$refs.popupRef.show
      this.$refs.popupRef.message = ''
    },
    /**
     * @description 弹窗确认后的callback
     */
    popupConfirmCallBack (message) {
      let list = []
      if (this.selectRow) {
        list = [{
          comment: message,
          id: this.selectRow.id,
          result: this.currentPopType
        }]
      } else {
        list = this.selectRows.map(i => {
          return {
            id: i.id,
            comment: message,
            result: this.currentPopType
          }
        })
      }
      this.setExamine(list)
    },
    async setExamine (list) {
      await this.examine(list)
      await this.handleGetList()
      this.selectRows = []
      this.checkedAll = false
      this.$refs['checkboxGroup'].toggleAll(false)
    },
    /**
     * @description 每次滚到到底部触发的加载逻辑
     * @return {Promise<void>}
     */
    async onLoad () {
      const flag = this.testTotal()
      if (flag) return
      this.finished = true
      this.loading = true
      this.query.current++
      this.loading = true
      await this.getTableDataConcat(this.query)
      this.testTotal()
    },
    /**
     * @description 校验当前列表条数是否已经全部加载 true为真
     * @return {boolean}
     */
    testTotal () {
      if (this.tableData.length >= this.total) {
        this.finished = true
        this.loading = true
        return true
      } else {
        this.finished = false
        this.loading = false
        return false
      }
    },
    /**
     * @description 列表下拉刷新时触发
     */
    onRefresh () {
      setTimeout(async () => {
        await this.handleGetList()
      }, 1000)
    },
    /**
     * @description 全选全部
     */
    handleCheckAll (check) {
      this.$refs['checkboxGroup'].toggleAll(!!check)
    },
    /**
     * @description 更新tab后的回调
     * @param v
     * @return {Promise<void>}
     */
    async handleChange (v) {
      this.query.status = v
      await this.handleGetList()
    },
    /**
     * @description 查询列表方法
     * @return {Promise<void>}
     */
    async getTableList () {
      this.loading = true
      this.query.current = 1
      await this.getTableData(this.query)
      this.loading = false
    },
    /**
     * @description 查询列表方法
     * @return {Promise<void>}
     */
    async handleGetList () {
      this.query.current = 1
      await this.getTableList()
      this.isLoading = false
      this.finished = false
    },
    /**
     * @description 日期选择后的回调函数
     * @param v
     * @return {Promise<void>}
     */
    async handleMonthCallBack (v) {
      this.monthPopup.flag = false
      if (v === 'recovery') {
        this.queryDateTitle = '请选择日期'
        this.query.submitStartTime = ''
        this.query.submitEndTime = ''
        await this.handleGetList()
        return
      }
      if (v.title) {
        this.queryDateTitle = moment(`${v.id}/${v.index}/1`).format('YYYY年MM月')
        this.query.submitStartTime = v.id + '-' + (v.index >= 10 ? v.index : '0' + v.index) + '-' + '01' + ' 00:00:00'
        if (v.index === 12) {
          this.query.submitEndTime = (Number(v.id) + 1) + '-' + '01' + '-' + '01' + ' 23:59:59'
        } else {
          this.query.submitEndTime = v.id + '-' + ((Number(v.index) + 1) >= 10 ? (Number(v.index) + 1) : '0' + (Number(v.index) + 1)) + '-' + '01' + ' 23:59:59'
        }
      } else {
        this.queryDateTitle = moment(`${moment().format('YYYY')}/${v}/1`).format('YYYY年MM月')
        this.query.submitStartTime = moment().format('YYYY') + '-' + (v >= 10 ? v : '0' + v) + '-' + '01' + ' 00:00:00'
        if (v === 12) {
          this.query.submitEndTime = (Number(moment().format('YYYY')) + 1) + '-' + '01' + '-' + '01' + ' 23:59:59'
        } else {
          this.query.submitEndTime = moment().format('YYYY') + '-' + ((Number(v) + 1) >= 10 ? (Number(v) + 1) : '0' + (Number(v) + 1)) + '-' + '01' + ' 23:59:59'
        }
      }
      await this.handleGetList()
    },
    /**
     * @description 选择顶部查询条件触发
     * @param type
     */
    handleChoice (type) {
      if (type === 'type') {
        this.typePopup.flag = true
      } else if (type === 'time') {
        this.monthPopup.flag = true
      }
    }
  }
}
</script>
<style scoped lang="less" src="./index.less" />
